var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"primary-btn",attrs:{"type":"button","disabled":_vm.disabled || _vm.loading}},'button',_vm.$attrs,false),[(_vm.loading)?_c('div',[_c('Spinner',{staticClass:"mr-3"})],1):_vm._e(),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }